export default {
  description: 'The new way to solve Identity'
};



// WEBPACK FOOTER //
// ./src/modules/metas-defaults/index.js